"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConfirmation = void 0;
const react_1 = __importDefault(require("react"));
const design_system_1 = require("@servicetitan/design-system");
exports.DefaultConfirmation = ({ negative = true, title = 'Are you sure?', message = '', onConfirm, onCancel, }) => (react_1.default.createElement(design_system_1.Dialog, { open: true, closable: true, negative: negative, onClose: onCancel, title: title, onPrimaryActionClick: onConfirm, primaryActionName: "Confirm", onSecondaryActionClick: onCancel, secondaryActionName: "Cancel" }, message));
//# sourceMappingURL=default-confirmation.js.map